import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import PollsBasicInfoComponent from './polls-basic-info.component';
import PollsMappedInfoComponent from './polles-mapped.component';

export const PollsComponent = ({
    selectPolls, handleInnerFormChange, back, handleFormSubmit, accountTypesListLoading, accountListLoading, accountsList, accountTypesList, policyOwnerType, templates,
    tenantFunctions,
    handleFormItemChange,
    deleteSelectedFunctions,
    handleProductSearch,
    handleDeliverySearch,
    handleTierPriceSearch,
    handleCollectionPolicySearch,
    handleRewardPointSearch,
    handleDiscountSearch,
    handleVendorSearch,
    handleTopicSearch,
    handleModuleSearch,
    handleLearningPathSearch,
    handleCourseSearch,
    handleCollectionSearch,
    handleChannelSearch,
    handleCertificateSearch,
    handleAnnouncementSearch,
    handleCategorySearch,
    products,
    deliveries,
    collectionPolicies,
    tierPrices,
    rewards,
    discounts,
    organizationUnits,
    vendors,
    topics,
    modules,
    learningPaths,
    courses,
    collections,
    channels,
    certificates,
    announcements,
    categories,
    selectedFunctions, websites, webpages, accounts, orgRegistries, dbas, PollTypeList,topicsList,comunityList,chapterList
}: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Basic Information',
            component: <PollsBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectPolls={selectPolls}
                policyOwnerType={policyOwnerType}
                accountTypesList={accountTypesList}
                accountTypesListLoading={accountTypesListLoading}
                accountsList={accountsList}
                accountListLoading={accountListLoading}
                PollTypeList={PollTypeList}
            />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Mapped Entities',
            component: <PollsMappedInfoComponent
                templates={templates}
                comunityList={comunityList}
                chapterList={chapterList}
                topicsList={topicsList}
                tenantFunction={tenantFunctions}
                selectedFunctions={selectedFunctions}
                categories={categories}
                deleteSelectedFunctions={deleteSelectedFunctions}
                handleInnerFormChange={handleInnerFormChange}
                handleFormItemChange={handleFormItemChange}
                announcements={announcements}
                // certificates={certificates}
                channels={channels}
                // collections={collections}
                // courses={courses}
                // learningPaths={learningPaths}
                // modules={modules}
                topics={topics}
                // vendors={vendors}
                organizationUnits={organizationUnits}
                discounts={discounts}
                rewards={rewards}
                tierPrices={tierPrices}
                collectionPolicies={collectionPolicies}
                deliveries={deliveries}
                products={products}
                handleCategorySearch={handleCategorySearch}
                handleAnnouncementSearch={handleAnnouncementSearch}
                // handleCertificateSearch={handleCertificateSearch}
                handleChannelSearch={handleChannelSearch}
                // handleCollectionSearch={handleCollectionSearch}
                // handleCourseSearch={handleCourseSearch}
                // handleLearningPathSearch={handleLearningPathSearch}
                // handleModuleSearch={handleModuleSearch}
                handleTopicSearch={handleTopicSearch}
                // handleVendorSearch={handleVendorSearch}
                handleDiscountSearch={handleDiscountSearch}
                handleRewardPointSearch={handleRewardPointSearch}
                handleCollectionPolicySearch={
                    handleCollectionPolicySearch
                }
                handleTierPriceSearch={handleTierPriceSearch}
                handleDeliverySearch={handleDeliverySearch}
                handleProductSearch={handleProductSearch}
                accounts={accounts}
                orgRegistries={orgRegistries}
                dbas={dbas}
            />,
            isVisible: true,
        },
    ];

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default PollsComponent;
